<template>
  <div class="container">
    <div class="total-wrap flex">
      <div
        class="item flex"
        v-for="item in topData"
        :key="item.title"
        @click="handleTopDataClick(item)"
      >
        <div class="title-wrap flex">
          <div class="title-text">{{ item.title }}</div>
        </div>
        <div>
          <p class="number">
            {{ item.value }}
          </p>
        </div>
      </div>
    </div>
    <el-form
      size="mini"
      ref="form"
      :model="searchInfo"
      label-width="80px"
      label-position="right"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="生日时间:" class="birthday-date">
            <el-date-picker
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              format="MM-dd"
              v-model="searchInfo.birthdayDate"
              @change="handleSearch('birthdayDate')"
              @focus="handleBirthdayFocus"
              :unlink-panels="true"
              class="datePicker"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="学员:" prop="key_word">
            <el-input
              v-model="searchInfo.key_word"
              placeholder="请输入学员姓名或手机号"
              @change="handleSearch"
              clearable
              maxlength="99"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别:" prop="sex">
            <el-radio-group v-model="searchInfo.sex" @change="handleSearch">
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">男</el-radio-button>
              <el-radio-button :label="2">女</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年龄分布:" prop="age_stage">
            <el-select
              v-model="searchInfo.age_stage"
              placeholder="请选择"
              clearable
              @change="handleSearch"
            >
              <el-option label="暂无年龄" :value="8"></el-option>
              <el-option label="X ≤ 3" :value="1"></el-option>
              <el-option label="3 < X ≤ 6" :value="2"></el-option>
              <el-option label="6 < X ≤ 9" :value="3"></el-option>
              <el-option label="9 < X ≤ 12" :value="4"></el-option>
              <el-option label="12 < X ≤ 15" :value="5"></el-option>
              <el-option label="15 < X ≤ 18" :value="6"></el-option>
              <el-option label="18 < X" :value="7"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="学员类型:" prop="student_type">
            <el-radio-group
              v-model="searchInfo.student_type"
              @change="handleSearch"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">意向</el-radio-button>
              <el-radio-button :label="2">在读</el-radio-button>
              <el-radio-button :label="3">历史</el-radio-button>
              <el-radio-button :label="4">回收</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      class="mwow-button-filled primary"
      @click="clickexport"
      v-debounce="1000"
      style="margin-bottom: 20px"
    >
      导出
    </div>
    <el-table
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @sort-change="clickStort"
    >
      <el-table-column
        label="序号"
        prop="serialNumber"
        width="50"
        type="index"
      ></el-table-column>
      <el-table-column
        label="生日日期"
        prop="birthday_month_day"
        sortable="custom"
        width="150"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
      <el-table-column label="学员姓名" prop="name" width="150">
        <template slot-scope="scope">
          <div
            style="color: #07d1aa; cursor: pointer"
            @click="toStudentDetail(scope.row)"
          >
            {{ scope.row.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="学员类型" prop="status" width="100">
        <template slot-scope="scope">
          {{ handleStudentStatus(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="mobile" width="150">
        <template slot-scope="scope">
          {{ "+" + scope.row.area_code }} {{ scope.row.mobile || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="性别" prop="sex" width="70">
        <template slot-scope="scope">
          <div v-if="scope.row.sex === 0">未知</div>
          <div v-if="scope.row.sex === 1">男</div>
          <div v-if="scope.row.sex === 2">女</div>
        </template>
      </el-table-column>
      <el-table-column label="年龄" prop="age" width="50">
        <template slot-scope="scope">
          {{ scope.row.age + "岁" }}
        </template>
      </el-table-column>

      <el-table-column label="用户意向" prop="intent" width="70">
        <template slot-scope="scope">
          {{ followLatentObj[scope.row.intent] || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="首次入学时间" prop="transform_time" width="150">
        <template slot-scope="scope">
          {{ scope.row.transform_time }}
        </template>
      </el-table-column>
      <el-table-column label="所在班级" prop="class_list">
        <template slot-scope="scope">
          {{
            scope.row.class_list && scope.row.class_list.length > 0
              ? scope.row.class_list.map((item) => item.name).join("，")
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="课程老师"
        prop="relation_teacher_list"
        width="250"
      >
        <template slot-scope="scope">
          {{
            scope.row.relation_teacher_list &&
            scope.row.relation_teacher_list.length > 0
              ? scope.row.relation_teacher_list
                  .map((item) => item.name)
                  .join("，")
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column label="教务老师" prop="teacher_name" width="100">
        <template slot-scope="scope">
          {{ scope.row.teacher_name ? scope.row.teacher_name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="课程顾问" prop="follow_staff_name" width="100">
        <template slot-scope="scope">
          {{ scope.row.follow_staff_name ? scope.row.follow_staff_name : "-" }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  dateFormat,
  getCurrentWeek,
  getNextWeek,
  getCurrentMonth,
  getCurrentSeason,
} from "@/utils/timeFormat";
import {
  studentBirthdayListApi,
  studentBirthdayListExportApi,
} from "@/api/studentManage";
import { getFollowLatentApi } from "@/api/studentFollow";
import { studentBirthdayStatisticsApi } from "@/api/statistics";
import { exportLoop } from "@/utils/export";
import { PageModule } from "@/store/module/page";

export default {
  props: ["visible"],
  data() {
    return {
      searchInfo: {
        sex: -1,
        student_type: -1,
        birthdayDate: "",
        sort_type: "asc",
        sort_field: "birthday_month_day",
      },
      topData: [
        {
          key: "today",
          title: "今天生日学员",
          value: "",
        },
        {
          key: "tomorrow",
          title: "明天生日学员",
          value: "",
        },
        {
          key: "this_week",
          title: "本周生日学员",
          value: "",
        },
        {
          key: "next_week",
          title: "下周生日学员",
          value: "",
        },
        {
          key: "this_month",
          title: "本月生日学员",
          value: "",
        },
        {
          key: "this_quarter",
          title: "本季度生日学员",
          value: "",
        },
      ],
      tableData: [],
      followLatent: [],
      followLatentObj: {},
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  mounted() {
    let birthdayDate = document.querySelector(".birthday-date");
    let datePicker = birthdayDate.querySelector(".datePicker");
    let elIconDate = datePicker.querySelector(".el-icon-date");
    elIconDate.style.display = "none";
  },
  methods: {
    init() {
      const searchListInfo = PageModule.pageInfo.teachManageBirthdayStudent;
      if (searchListInfo.page) {
        this.page = searchListInfo.page || this.page;
      }
      if (searchListInfo.page_size) {
        this.pageSize = searchListInfo.page_size || this.pageSize;
      }
      // 如果缓存了数据后，返回该页面，则使用缓存的 serchInfo 数据调接口
      let type = this.$route.query.type || "this_month";
      if (
        searchListInfo.search_info &&
        this.$route.query.from === "studentdetails"
      ) {
        this.searchInfo = searchListInfo.search_info;
        this.page = this.searchInfo.page || 1;
        this.getList({
          page: this.searchInfo.page,
          page_size: this.pageSize,
        });
      } else {
        // 如果是首次进入该页面，默认时间为 this_month
        this.searchRangeChange(type);
      }
      this.getStudentBirthdayStatistics();
      getFollowLatentApi().then((res) => {
        this.followLatent = res.data.list;
        const obj = {};
        res.data.list.map((item) => {
          obj[item.key] = item.value;
        });
        this.followLatentObj = obj;
      });
    },
    solveSearchInfo(option) {
      let params = { ...option };
      if (this.searchInfo.sort_type) {
        params.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field) {
        params.sort_field = this.searchInfo.sort_field;
      }
      if (
        this.searchInfo.birthdayDate &&
        this.searchInfo.birthdayDate.length > 0
      ) {
        params.birthday_month_start = Number(
          new Date(this.searchInfo.birthdayDate[0]).getMonth() + 1
        );
        params.birthday_month_end = Number(
          new Date(this.searchInfo.birthdayDate[1]).getMonth() + 1
        );
        params.birthday_day_start = Number(
          new Date(this.searchInfo.birthdayDate[0]).getDate()
        );
        params.birthday_day_end = Number(
          new Date(this.searchInfo.birthdayDate[1]).getDate()
        );
      }
      if (this.searchInfo.key_word) {
        params.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.sex && this.searchInfo.sex > 0) {
        params.sex = this.searchInfo.sex;
      }
      if (this.searchInfo.age_stage) {
        params.age_stage = this.searchInfo.age_stage;
      }
      // 意向,在读,历史类型
      if (
        this.searchInfo.student_type > 0 &&
        this.searchInfo.student_type <= 3
      ) {
        params.student_type = this.searchInfo.student_type;
      }
      // 回收类型
      if (this.searchInfo.student_type === 4) {
        params.is_recycle = 1;
      }
      return params;
    },
    handleSearch() {
      this.page = 1;
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
      this.getStudentBirthdayStatistics();
    },
    getList(option) {
      let params = this.solveSearchInfo(option);
      studentBirthdayListApi(params).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            item.transform_time = item.transform_time
              ? dateFormat("YYYY-mm-dd HH:MM", item.transform_time * 1000)
              : "-";
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    getStudentBirthdayStatistics() {
      studentBirthdayStatisticsApi().then((res) => {
        if (res.error_code === 0) {
          this.topData = this.topData.map((item) => {
            for (let it in res.data.info) {
              if (item.key === it) {
                item.value = res.data.info[it];
                continue;
              }
            }
            return item;
          });
        }
      });
    },
    clickexport() {
      let params = this.solveSearchInfo({
        page: this.page,
        pageSize: this.pageSize,
      });
      studentBirthdayListExportApi(params).then((res) => {
        if (res.error_code == 0) {
          exportLoop(res.data.task_id);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handleStudentStatus(row) {
      let text = "-";
      if (row.is_recycle === 1) {
        text = "回收学员";
      } else {
        if (row.status === 1) {
          text = "意向学员";
        } else if (row.status === 2) {
          text = "在读学员";
        } else if (row.status === 3) {
          text = "历史学员";
        }
      }

      return text;
    },
    handleBirthdayFocus() {
      let body = document.body;
      let elPickerPanel = body.querySelector(".el-picker-panel");
      let birthdayDate = document.querySelector(".birthday-date");
      let datePicker = birthdayDate.querySelector(".datePicker");
      let elIconDate = datePicker.querySelector(".el-icon-date");
      elIconDate.style.display = "inline-block";
      if (elPickerPanel) {
        let elPickerHeader = elPickerPanel.querySelectorAll(
          ".el-date-range-picker__header"
        );
        elPickerHeader.forEach((item) => {
          let arrowDLeft = item.querySelector(".el-icon-d-arrow-left"); // 切换年份
          let arrowLeft = item.querySelector(".el-icon-arrow-left"); // 切换月份
          let arrowDRight = item.querySelector(".el-icon-d-arrow-right"); // 切换年份
          let arrowRight = item.querySelector(".el-icon-arrow-right"); // 切换月份
          let div = item.querySelector("div");
          div.style.display = "none"; // 不能直接操作 item>div 元素
          let p = item.querySelector("p");
          // 如果 p 不存在，创建添加 p
          if (!p) {
            // 创建 p 进行操作
            let p0 = document.createElement("p");
            // 只获取末尾的月份
            let div0 = elPickerHeader[0].querySelector("div");
            p0.innerText = div0.innerText.slice(-4);
            // 追加 p
            elPickerHeader[0].appendChild(p0);
            let p1 = document.createElement("p");
            let div1 = elPickerHeader[1].querySelector("div");
            if (this.searchInfo.birthdayDate) {
              // 如果开始月份 === 结束月份，则可用 item>div 的 innerText
              if (
                new Date(this.searchInfo.birthdayDate[0]).getMonth() + 1 ===
                new Date(this.searchInfo.birthdayDate[1]).getMonth() + 1
              ) {
                p1.innerText = div1.innerText.slice(-4);
              } else {
                // 如果不相等，需使用结束月份
                p1.innerText =
                  new Date(this.searchInfo.birthdayDate[1]).getMonth() +
                  1 +
                  " 月";
              }
            } else {
              p1.innerText = div1.innerText.slice(-4);
            }
            elPickerHeader[1].appendChild(p1);
          } else {
            // 如果 p 已存在，重新为结束月份赋值
            let p0 = elPickerHeader[0].querySelector("p");
            let div0 = elPickerHeader[0].querySelector("div");
            let p1 = elPickerHeader[1].querySelector("p");
            let div1 = elPickerHeader[1].querySelector("div");
            if (this.searchInfo.birthdayDate) {
              if (
                new Date(this.searchInfo.birthdayDate[0]).getMonth() + 1 ===
                new Date(this.searchInfo.birthdayDate[1]).getMonth() + 1
              ) {
                p1.innerText = div1.innerText.slice(-4);
                p0.innerText = div0.innerText.slice(-4);
              } else {
                p1.innerText =
                  new Date(this.searchInfo.birthdayDate[1]).getMonth() +
                  1 +
                  " 月";
              }
            } else {
              p0.innerText = div0.innerText.slice(-4);
              p1.innerText = new Date().getMonth() + 2 + " 月";
            }
          }
          this.$nextTick(() => {
            // 切换年份按钮，隐藏
            if (arrowDLeft) {
              arrowDLeft.style.display = "none";
            }
            // 切换年份按钮，隐藏
            if (arrowDRight) {
              arrowDRight.style.display = "none";
            }
            // 切换月份，动态截取 innerText
            if (arrowLeft) {
              arrowLeft.addEventListener("click", () => {
                let copyp0 = elPickerHeader[0].querySelector("p");
                let div0 = elPickerHeader[0].querySelector("div");
                let copyp1 = elPickerHeader[1].querySelector("p");
                let div1 = elPickerHeader[1].querySelector("div");
                copyp0.innerText = div0.innerText.slice(-4);
                copyp1.innerText = div1.innerText.slice(-4);
              });
            }
            // 切换月份，动态截取 innerText
            if (arrowRight) {
              arrowRight.addEventListener("click", () => {
                let copyp0 = elPickerHeader[0].querySelector("p");
                let div0 = elPickerHeader[0].querySelector("div");
                let copyp1 = elPickerHeader[1].querySelector("p");
                let div1 = elPickerHeader[1].querySelector("div");
                copyp0.innerText = div0.innerText.slice(-4);
                copyp1.innerText = div1.innerText.slice(-4);
              });
            }
          });
        });
      }
    },
    searchRangeChange(type) {
      let start = "";
      let end = "";
      const now = new Date();
      switch (type) {
        case "today":
          start = dateFormat("YYYY-mm-dd", now);
          end = dateFormat("YYYY-mm-dd", now);
          break;
        case "tomorrow":
          start = dateFormat("YYYY-mm-dd", now.getTime() + 24 * 60 * 60 * 1000);
          end = dateFormat("YYYY-mm-dd", now.getTime() + 24 * 60 * 60 * 1000);
          break;
        case "this_week":
          const this_week = getCurrentWeek(now);
          start = dateFormat("YYYY-mm-dd", this_week[0]);
          end = dateFormat(
            "YYYY-mm-dd",
            dateFormat("YYYY-mm-dd", this_week[1])
          );
          break;
        case "next_week":
          const next_week = getNextWeek(now);
          start = dateFormat("YYYY-mm-dd", next_week[0]);
          end = dateFormat("YYYY-mm-dd", next_week[1]);
          break;
        case "this_month":
          const this_month = getCurrentMonth(now);
          start = dateFormat("YYYY-mm-dd", this_month[0]);
          end = dateFormat("YYYY-mm-dd", this_month[1]);
          break;
        case "this_quarter":
          const this_quarter = getCurrentSeason(now);
          start = dateFormat("YYYY-mm-dd", this_quarter[0]);
          end = dateFormat("YYYY-mm-dd", this_quarter[1]);
          break;
      }
      if (type) {
        this.searchInfo.birthdayDate = [start, end];
      } else {
        this.searchInfo.birthdayDate = [];
      }
      this.page = 1;
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    toStudentDetail(row) {
      this.searchInfo.page = this.page;
      PageModule.SET_PAGE_INFO({
        name: "teachManageBirthdayStudent",
        key: "search_info",
        value: this.searchInfo,
      });
      this.$router.push({
        name: "studyDetails",
        query: {
          id: row.student_id,
          from: "studentBirthday",
        },
      });
    },
    handleTopDataClick(item) {
      this.page = 1;
      PageModule.SET_PAGE_INFO({
        name: "teachManageBirthdayStudent",
        key: "page",
        value: this.page,
      });
      this.searchRangeChange(item.key);
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "teachManageBirthdayStudent",
        key: "page",
        value: e,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: this.page,
        page_size: e,
      });
      PageModule.SET_PAGE_INFO({
        name: "teachManageBirthdayStudent",
        key: "page_size",
        value: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  .total-wrap {
    margin: 0 16px 16px 0;
    width: 100%;
    .item {
      flex: 1.5;
      padding: 10px 0;
      border-right: 1px solid #f1f2f2;
      flex-direction: column;
      background: #f6fafc;
      color: #5c5d5e;
      cursor: pointer;
      .title-wrap {
        font-size: 12px;
        line-height: 28px;
        display: flex;
        align-items: center;
        .title-text {
          font-size: 14px;
        }
      }
      .number {
        font-size: 20px;
        font-weight: bold;
        line-height: 42px;
        color: #4fb77c;
      }
    }
    .item:nth-child(4) {
      border: none;
    }
  }
  /deep/ .el-form {
    .el-form-item {
      width: 100%;
      display: flex;
      .el-form-item__label {
        min-width: 88px;
        text-align: right;
      }
      .el-form-item__content {
        margin-right: 58px;
        margin-left: 0 !important;
        width: 100%;
        flex: 1;
        .inputBox {
          display: flex;
          position: relative;
          &:hover {
            .clear-icon {
              display: block;
            }
          }
          .clear-icon {
            position: absolute;
            top: 8px;
            right: 0;
            font-size: 14px;
            color: #d8d8d8;
            cursor: pointer;
            display: none;
          }
          .el-input {
            width: auto;
            text-align: center;
          }
        }
      }

      .el-select {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }
    }
    .birthday-date {
      .el-date-editor {
        input {
          width: 50%;
          height: 28px !important;
        }
      }
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
